import {
  DOWNLOAD_FILE_ADD,
  DOWNLOAD_FILES_ADD,
  DOWNLOAD_FILE_UPDATE,
  DOWNLOAD_CLEAR
} from '../types'

const initialState = {
  files: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DOWNLOAD_FILE_ADD:
      return {
        ...state,
        files: [
          ...state.files,
          action.payload
        ]
      }

    case DOWNLOAD_FILES_ADD:
      return {
        ...state,
        files: [
          ...state.files,
          ...action.payload
        ]
      }

    case DOWNLOAD_CLEAR:
      return {
        ...state,
        files: initialState.files
      }

    case DOWNLOAD_FILE_UPDATE:
      return {
        ...state,
        files: state.files.map(file => file.guid === action.payload.guid ? {
          guid: file.guid,
          name: file.name,
          percent: action.payload.percent
        } : file)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/download.js